import type { FinancialDocumentListItem } from "@common/types/financialDocument";
import { useFinancialDocumentBulkSelection } from "@components/documents/FinancialDocumentBulkSelection/useFinancialDocumentBulkSelection";
import { identity } from "../../chatDrag/identity";
import { useRowChatDrag } from "../../chatDrag/useRowChatDrag";
import { useAddDocumentsToChat } from "../../useAddDocumentsToChat";

/** `rowDragOut` for the financial documents table: drags documents into the task chat. */
export function useFinancialDocumentRowChatDrag() {
    const { selected, hasSelectedByCurrentFilters, clearSelection } =
        useFinancialDocumentBulkSelection();
    const { canAddToChat, addDocumentsToChat } = useAddDocumentsToChat();
    return useRowChatDrag({
        noun: "document",
        canAddToChat,
        getRowItem: identity<FinancialDocumentListItem>,
        selectedItems: selected,
        isSelectAll: hasSelectedByCurrentFilters,
        addToChat: addDocumentsToChat,
        clearSelection,
    });
}
